<template>
  <div>
    <h5 class="display-5">Register Student</h5>
    <h6 class="display-6">
      To register student, you need to fill all the form on following below.
      After you have done register, your registered student will appear on the
      list.
    </h6>
    <br />
    <CCard class="mt-3">
      <div class="mx-auto d-flex justify-content-center col-12 ml-1 mt-1">
        <div class="text-center custom-width-lg p-0">
          <CRow class="justify-content-center p-0 mt-5 mb-2">
            <CCol sm="12" lg="12">
              <CRow>
                <CCol sm="12" lg="12">
                  <CInput type="text" v-model="user.tuitioncenter" disabled />
                </CCol>
                <CCol sm="12" lg="12">
                  <CInput
                    type="text"
                    v-model="FullName"
                    placeholder="Enter Student Name"
                  />
                </CCol>
                <CCol sm="12" lg="12">
                  <CInput
                    type="text"
                    placeholder="Enter Your Age"
                    v-model="Age"
                  />
                </CCol>
                <CCol sm="4" lg="4">
                  <h6 class="text-left text-dark">Gender</h6>
                </CCol>
                <CCol sm="8" lg="8" class="text-left">
                  <input type="radio" v-model="gender" value="Female" />
                  <span class="text-dark"> Female</span>
                  <input
                    type="radio"
                    class="text-dark ml-3"
                    v-model="gender"
                    value="Male"
                  />
                  <span class="text-dark"> Male</span>
                </CCol>
                <CCol sm="12" lg="12" class="text-left mt-3">
                  <CInput
                    type="text"
                    v-model="MainContact"
                    placeholder="Enter Your Main Phone Number"
                  />
                </CCol>
                <CCol sm="12" lg="12" class="text-left">
                  <v-select
                    v-model="SelectedGrade"
                    :options="grades"
                    label="GradeName"
                    placeholder="--Please Select Grade--"
                  ></v-select>
                </CCol>
                <CCol sm="12" lg="12" class="mt-3 text-left">
                  <CInput
                    type="text"
                    v-model="ParentName"
                    placeholder="Enter Your Parent Name"
                  />
                </CCol>
                <CCol sm="12" lg="12" class="text-left">
                  <CInput
                    type="text"
                    v-model="ParentEmail"
                    placeholder="Enter Your Parent Email"
                  />
                </CCol>
                <CCol sm="12" lg="12" class="text-left">
                  <CInput
                    type="text"
                    v-model="StudentEmail"
                    placeholder="Enter Student Email"
                  />
                </CCol>
              </CRow>
              <CButton
                style="border-radius: 10px"
                color="success"
                class="custom-btn"
                size="lg"
                @click="InsertManualStudent"
                block
                >Register New</CButton
              >
              <br />

              <CCol sm="12">
                <div v-if="ErrorMessageLimit == true" class="ml-4 mr-4">
                  <CAlert show color="danger">
                    <strong class="text-danger mr-2"
                      >X ERROR ! You have reached limit register student</strong
                    >
                  </CAlert>
                </div>
                <div v-if="ErrorMessageNotComplete == true" class="ml-4 mr-4">
                  <CAlert show color="danger">
                    <strong class="text-danger mr-2"
                      >X ERROR ! Please Complete all the form</strong
                    >
                  </CAlert>
                </div>
                <div v-if="ErrorMessage == true" class="ml-4 mr-4">
                  <CAlert show color="danger">
                    <strong class="text-danger mr-2"
                      >X ERROR ! This student is already registered”</strong
                    >
                  </CAlert>
                </div>
                <div v-if="SuccessMessage == true" class="ml-4 mr-4">
                  <CAlert show color="success"
                    >You have successfully register student</CAlert
                  >
                </div>
              </CCol>
            </CCol>
          </CRow>
        </div>
      </div>
    </CCard>
  </div>
</template>

 
<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import FullCalendar from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.css";
import backgroundUrl from "../assets/img/bgCard.png";
import VCalendar from "v-calendar";
import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";
import $ from "jquery";

import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { CChartBar } from "@coreui/vue-chartjs";
import VueEllipseProgress from "vue-ellipse-progress";

//import "@fullcalendar/core/vdom"; // solves problem with Vite]

import { Calendar } from "vue-sweet-calendar";
import "vue-sweet-calendar/dist/SweetCalendar.css";

Vue.use(FullCalendar);
Vue.use(VueEllipseProgress);

export default {
  name: "Collapses",
  components: {
    PulseLoader,
    CChartBar,
    Calendar,
    VCalendar,
    VueCal,
  },
  data() {
    return {
      backgroundUrl,
      //users: {},
      user: {},
      news: [],
      schedule: [],
      childs: [],
      parents: {},
      grades: [],

      SelectedGrade: "",
      TuitionCenterCode: "",
      Age: "",
      ParentName: "",
      ParentEmail: "",
      Age: "",
      gender: "",
      MainContactNumber: "",
      FullName: "",
      StudentEmail: "",
      ErrorMessageLimit: false,

      SuccessMessage: false,
      ErrorMessage: false,
      ErrorMessageNotComplete: false,

      check: {},
    };
  },
  async mounted() {
    this.SessionUserIdNo();
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetGrade();
      this.GetCheckTc();
    } else {
      this.GoToLogin();
    }
  },

  methods: {
    SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetailAdmin, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetGrade();
            this.GetCheckTc(this.user.tuitioncenter);
          }
        });
    },
    GetCheckTc(tuitioncenter) {
      return this.$API
        .get(this.$GetCheckTcPackage + "?TuitionCenterId=" + tuitioncenter, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.check = response.data;
          }
        });
    },
    GetGrade() {
      this.$API
        .get(this.$ListGrade, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.grades = response.data;
          }
        });
    },
    InsertManualStudent() {
      if (
        this.SelectedGrade == null ||
        this.FullName == null ||
        this.Age == null
      ) {
        this.ErrorMessageNotComplete = true;
      } else {
        if (this.check.CurrentCountStudent >= this.check.NumberOfStudent) {
          this.ErrorMessageLimit = true;
        } else {
          const formData = new FormData();

          formData.append("Name", this.FullName);
          formData.append("ParentPhoneNumber", this.MainContact);
          formData.append("Grade", this.SelectedGrade.GradeName);
          formData.append("ParentName", this.ParentName);
          formData.append("ParentEmail", this.ParentEmail);
          formData.append("TuitionCenterId", this.user.tuitioncenter);

          return this.$API
            .post(this.$RegisterManualStudentTc, formData, {
              withCredentials: true,
            })
            .then((response) => {
              if (response.status == 200 && response.data != null) {
                if (response.data > 0) {
                  this.FullName = "";
                  this.Age = "";
                  this.SelectedGrade = 0;
                  this.SuccessMessage = true;
                  this.$router.back();
                  // this.$router.push("/JoinGroup?codeId=" + this.$route.query.codeId);
                } else {
                  this.ErrorMessage = true;
                }
              } else if (response.status == 500) {
                this.ErrorMessageNotComplete = true;
              } else {
                this.ErrorMessageNotComplete = true;
              }
            })
            .catch((error) => {
              if (error.response) {
                console.log(error.response.status);
                this.Error = true;
                this.Message = error;
                this.Message = "Error";
                this.ErrorMessageNotComplete = true;
              }
            });
        }
      }
    },
    GoToJoinGroup() {
      this.$router.back();
      // this.$router.push("/JoinGroup?codeId=" + this.$route.query.codeId);
    },
  },
};
</script>


<style>
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@600&display=swap");
</style>

